import { ButtonBase, Drawer, DrawerProps, styled } from '@mui/material';
import { ReactElement } from 'react';

export interface PoolDrawerProps extends Omit<DrawerProps, 'onClose'> {
    onClose?: () => void;
}

export const PoolDrawer = (props: PoolDrawerProps): ReactElement => {
    return (
        <Drawer
            {...props}
            PaperProps={{
                ...props.PaperProps,
                sx: { width: '100%', position: 'relative', zIndex: 10, ...props.PaperProps?.sx },
            }}
        />
    );
};

export const PoolDrawerHeader = styled(ButtonBase)(({ theme }) => ({
    ...theme.typography.h5,
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    minHeight: theme.spacing(10),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    justifyContent: 'start',
    gap: theme.spacing(3),
    textAlign: 'left',
}));
